const color = {

    'white': '#FFFFFF',
    'red': '#FF0B0B',
    'blue': '#0d6efd',
    'light-blue': '#00E1FF',
    // 'statusBadge(orange)': '#f97316',
    // 'statusBadge(green)': '#22c55e',
    'riskMedium': '#EDB534',
    'riskLow': '#10B981',
    'riskHigh': '#E56A49',
    'riskCritical': '#A8020B',
    'riskGreen': '#10B981',
    'text(grey)': '#94A3B8',
    'primary(blue)': '#3b82f6',
    'critical(red)': '#790000',
    'high(red)': '#DC1034',
};

export const theme = {
    surface: '#0d1117',              // panel background
    border: '#1f2937',               // panel border + header/section dividers
    headerBg: 'rgba(14, 22, 40, 0.6)', // panel header background
    itemBorder: '#161b22',           // row separator
    shadow: '0 12px 32px rgba(0, 0, 0, 0.45)',
    scrollThumb: '#1e293b',

    titleText: '#e2e8f0',            // headings / row titles
    bodyText: '#94a3b8',             // body / secondary text
    mutedText: '#64748b',            // dates / empty states

    primary: '#3b82f6',              // links / actions
    danger: '#ef4444',
    // badge accents
    successBg: 'rgba(34, 197, 94, 0.15)',
    successText: '#22c55e',
};

export default color;